import React from "react"

import { Content } from "./components/Content"
import { Layout } from "../../../components/Generic/Layout/Layout"
import type { FormattedLegal } from "../../../libs/prismic/legal"
import { useUrl } from "../../../libs/router"

export type LegalScreenProps = {
  legalPage: FormattedLegal
  embed?: boolean
  uid: string
}

const LegalScreen = ({ uid, legalPage, embed }: LegalScreenProps) => {
  const { absolutePath } = useUrl()
  const { metaTitle, metaDescription } = legalPage

  if (embed) return <Content legalPage={legalPage} embed={embed} />

  return (
    <Layout
      headProps={{
        alternates: uid === "impressum" ? [] : undefined,
        url: absolutePath,
        title: metaTitle,
        description: metaDescription,
      }}>
      <Content legalPage={legalPage} />
    </Layout>
  )
}

export default LegalScreen
